'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Visible = function (_BaseIcon) {
  (0, _inherits3.default)(Visible, _BaseIcon);

  function Visible() {
    (0, _classCallCheck3.default)(this, Visible);
    return (0, _possibleConstructorReturn3.default)(this, (Visible.__proto__ || (0, _getPrototypeOf2.default)(Visible)).apply(this, arguments));
  }

  (0, _createClass3.default)(Visible, [{
    key: 'render',
    value: function render() {
      var svgColor = this.props.fill !== 'inherit' ? this.props.fill : '#000';
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('path', { d: 'M-1-4h24v24H-1' }),
          _react2.default.createElement('path', { d: 'M11 .5C6 .5 1.73 3.6 0 8c1.73 4.4 6 7.5 11 7.5s9.27-3.1 11-7.5C20.27 3.6 16 .5 11 .5zM11 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8C9.34 5 8 6.34 8 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z', fill: svgColor })
        )
      );
    }
  }]);
  return Visible;
}(_BaseIcon3.default);
/*eslint-enable */


Visible.defaultProps = {
  width: 22,
  height: 16,
  viewBox: '0 0 22 16'
};
exports.default = Visible;
//# sourceMappingURL=Visible.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Visible.js
// module id = 330
// module chunks = 0